class StatusBannerController {

    shouldDisplay () {
        return this.showOnlineBanner() || this.showPhoneBanner();
    }

    itemType () {
        return this.item && this.item.type;
    }

    showPhoneBanner () {
        return this.type === 'phone' && (this.status === 'telephone booking' || (this.item && this.item.phone_only));
    }

    showOnlineBanner () {
        return this.type === undefined && this.status === 'online only' ;
    }
}

StatusBannerController.$inject = [];

export default StatusBannerController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/controllers/statusBanner.controller.js